import './CuponeraSeats.less';

import * as actions from './redux/actions';
import * as homeActions from '../home/redux/actions';

import { KuposSelectBox, KuposSteps, KuposSuccessFailure } from '../common';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';

import ApiUrls from '../../services/apiUrls';
import CommonService from '../../services/commonService';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../themes/functions/getIcons/getIcons';

const operator = CommonService.getLocal('op');
const loginData = CommonService.getLocal('loginData');



const stepsMenu = [
	{ label: 'GOING', active: true },
	{ label: 'PAYMENT' },
	{ label: 'CONFIRMATION' },
];

const errorInitialState = {
	source: '',
	destination: '',
	date: '',
};

const CuponeraSeats = ({ home, actions, cuponera, history, t, common }) => {
	const operator = CommonService.getLocal('op');
	const destinationRef = useRef({});
	console.log("check the value of cuponera", cuponera)
	const { cuponeraSeats, selectedCuponera, cuponeraLoading } = cuponera;
	const { fetchCuponeraSeats, setSelectCuponera, setCuponeraSeats } = actions;
	const [error, setError] = useState(errorInitialState);
	const [myCoupons, setMyCoupons] = useState(cuponeraSeats);
	const localSeats = localStorage.getItem("localCuponera");
	const travelId = operator && operator.travel_ids;


	const styles = operator
		? `
.cuponera-sidebar-total-sum-box {
	background-color: ${operator.color_codes.secondary_color};
	color: white;
}
.cuponera-ticket-box-total-sum-box {
	background-color: #aaa;
	color: white;
}
.cuponera-sidebar-hr {
	background-color: ${operator.color_codes.primary_color};
}
.cuponera-ticket-box-relative-selected .cuponera-ticket-box-total-sum-box {
	background-color: ${operator.color_codes.secondary_color};
	color: white;
}
.loader-cricle {
	background-color: ${operator.color_codes.primary_color};
}
`
		: '';

	console.log("heeeeeeeeee", operator);
	useEffect(() => {

		// console.log("logggggggggggg localSeats", localSeats)

		if (cuponeraSeats && Object.values(cuponeraSeats).length) {
			localStorage.setItem("localCuponera", JSON.stringify(cuponeraSeats))
			setMyCoupons(cuponeraSeats)
		} else if (localSeats) {
			const localCuponera = JSON.parse(localSeats);
			setMyCoupons(localCuponera);
		}
	}, [cuponera, cuponeraSeats, localSeats])

	const onSourceChange = value => {
		setError({ ...error, source: null });
		actions.pbSetSourceCity(value);
		getOriginSelectedFilteredDestinations(home.uniqueCities, home.pbSourceCity);

		if (home.pbDestinationCity && value.value === home.pbDestinationCity.value) {
			onDestinationChange(null);
		}

		destinationRef.current.onMenuOpen();
		destinationRef.current.select.focus();
	};

	const onDestinationChange = value => {
		setError({ ...error, destination: null });
		actions.pbSetDestinationCity(value);
	};

	const getOriginSelectedFilteredDestinations = (rawArray, itemToRemove) => {
		if (rawArray && itemToRemove) {
			return rawArray
				.map(function (obj) {
					if (obj.label == itemToRemove.label) {
					} else {
						return obj;
					}
				})
				.filter(function (obj) {
					return typeof obj !== 'undefined';
				});
		} else if (!itemToRemove) {
			// return rawArray;
		}
	};

	const onStepClick = () => { };

	useEffect(() => {
		// if (!loginData) {
		// 	history.push('/');
		// }
		if (home.pbSourceCity && home.pbDestinationCity && travelId) {
			fetchCuponeraSeats({
				url: ApiUrls.cuponeraSeats(
					home.pbSourceCity.value,
					home.pbDestinationCity.value,
					operator && operator.travel_ids,
				),
			});
			// commenting this code 
			// if (!(cuponeraSeats && cuponeraSeats.length)) {
			//   let cuponeraSeatsTemp = JSON.parse(sessionStorage.getItem('cuponeraSeats'));
			//   if (cuponeraSeatsTemp) {
			//     setCuponeraSeats(cuponeraSeatsTemp);
			//   } else {

			//     fetchCuponeraSeats({
			//       url: ApiUrls.cuponeraSeats(
			//         home.pbSourceCity.value,
			//         home.pbDestinationCity.value,
			//         operator.travel_ids,
			//       ),
			//     });
			//   }
			// }
		} else if (travelId) {
			let source = JSON.parse(sessionStorage.getItem('cuponeraSourceCity'));
			let destination = JSON.parse(sessionStorage.getItem('cuponeraDestinationCity'));
			if (source && destination) {
				actions.pbSetSourceCity(source);
				actions.pbSetDestinationCity(destination);
			} else {
				history.push('/');
			}
		}


	}, [travelId]);

	const onContinueBtnClicked = () => {

		sessionStorage.setItem('selectedCuponera', JSON.stringify(selectedCuponera));
		sessionStorage.setItem('cuponeraSeats', JSON.stringify(cuponeraSeats));
		history.push('/cuponera/payment');

	};

	return (
		<div>
			<style>{styles}</style>
			{cuponeraLoading ? (
				<div className="loader-cricle-wrapper">
					<div className="loader-cricle"></div>
				</div>
			) : (
				<div className="content-container">
					{!!Object.keys(myCoupons).length && !cuponeraLoading ? (
						<React.Fragment>
							<KuposSteps menuButtons={stepsMenu} t={t} onStepClick={onStepClick} />
							<div className="cuponera-wrapper">
								<div>

									{operator && operator.operator_name === "tacoha" ?
										(<div className="cuponera-ticket-box-wrapper tachoha-icon-size">
											{(myCoupons[
												`${home.pbSourceCity.value}-${home.pbDestinationCity.value}`
											] || []).map(
												(
													{
														no_of_coupons,
														operator_name,
														origin,
														destination,
														total_discount_amount,
														total_net_amount,
														total_coupon_amount,
														zone_id,
														...props
													},
													index,
												) => {
													return (
														<div
															key={index}
															className={`cuponera-ticket-box-relative ${selectedCuponera &&
																zone_id === selectedCuponera.zone_id &&
																'cuponera-ticket-box-relative-selected'}`}
															onClick={() => {
																setSelectCuponera({
																	no_of_coupons,
																	operator_name,
																	origin,
																	destination,
																	total_discount_amount,
																	total_net_amount,
																	zone_id,
																	total_coupon_amount,
																	...props,
																});
															}}
														>
															<div className="cuponera-ticket-box kupos-card">
																<span className="font12">Cuponera</span>
																<br />
																<span className="font12 bold-text">{no_of_coupons} Pasajes</span>
																<div
																	style={{
																		background: 'rgb(187, 187, 187)',
																		height: 1,
																		margin: '20px 0',
																	}}
																></div>
																<div>
																	<p className="font9 mb-1">Empresa</p>

																	{operator && operator.operator_name === "tacoha" ? (<p className="font12 bold-text">Tacoha</p>) : (<p className="font12 bold-text">{operator_name}</p>)
																	}
																</div>
																<div className="location-details">
																	<div className="city-name font11 mb-1">
																		<img
																			className="icon-source"
																			src={getIcons('Origin', operator)}
																			alt={t('TRANSLATIONS.ICON_SOURCE')}
																		/>
																		<span className="font9">{origin}</span>
																	</div>
																	<div className="city-name font11">
																		<img
																			className="icon-source"
																			src={getIcons('Destination', operator)}
																			alt={t('TRANSLATIONS.ICON_SOURCE')}
																		/>
																		<span className="font9">{destination}</span>
																	</div>
																</div>
															</div>
															<div className="cuponera-ticket-box-total-sum-box">
																<span className="font9 bold-text">Total</span>
																<span className="font9 bold-text">
																	CLP {CommonService.currency(total_coupon_amount)}
																</span>
															</div>
														</div>
													);
												},
											)}
										</div>) :
										(
											<div className="cuponera-ticket-box-wrapper">
												{(cuponeraSeats[
													`${home.pbSourceCity.value}-${home.pbDestinationCity.value}`
												] || []).map(
													(
														{
															no_of_coupons,
															operator_name,
															origin,
															destination,
															total_discount_amount,
															total_net_amount,
															total_coupon_amount,
															zone_id,
															...props
														},
														index,
													) => {
														return (
															<div
																key={index}
																className={`cuponera-ticket-box-relative ${selectedCuponera &&
																	zone_id === selectedCuponera.zone_id &&
																	'cuponera-ticket-box-relative-selected'}`}
																onClick={() => {
																	setSelectCuponera({
																		no_of_coupons,
																		operator_name,
																		origin,
																		destination,
																		total_discount_amount,
																		total_net_amount,
																		zone_id,
																		total_coupon_amount,
																		...props,
																	});
																}}
															>
																<div className="cuponera-ticket-box kupos-card">
																	<span className="font12">Cuponera</span>
																	<br />
																	<span className="font12 bold-text">{no_of_coupons} Pasajes</span>
																	<div
																		style={{
																			background: 'rgb(187, 187, 187)',
																			height: 1,
																			margin: '20px 0',
																		}}
																	></div>
																	<div>
																		<p className="font9 mb-1">Empresa</p>
																		{operator && operator.operator_name === "tacoha" ? (<p className="font12 bold-text">Tacoha</p>) : (<p className="font12 bold-text">{operator_name}</p>)
																		}

																	</div>
																	<div className="location-details">
																		<div className="city-name font11 mb-1">
																			<img
																				className="icon-source"
																				src={getIcons('Origin', operator)}
																				alt={t('TRANSLATIONS.ICON_SOURCE')}
																			/>
																			<span className="font9">{origin}</span>
																		</div>
																		<div className="city-name font11">
																			<img
																				className="icon-source"
																				src={getIcons('Destination', operator)}
																				alt={t('TRANSLATIONS.ICON_SOURCE')}
																			/>
																			<span className="font9">{destination}</span>
																		</div>
																	</div>
																</div>
																<div className="cuponera-ticket-box-total-sum-box">
																	<span className="font9 bold-text">Total</span>
																	<span className="font9 bold-text">
																		CLP {CommonService.currency(total_coupon_amount)}
																	</span>
																</div>
															</div>
														);
													},
												)}
											</div>)
									}



									{selectedCuponera && (
										<div className="kupos-card font9">
											<p
												className="bold-text"
												style={{
													marginBottom: 6,
												}}
											>
												Información importante
											</p>


											{operator && operator.operator_name === "tacoha" ? (<p
												style={{
													marginBottom: 22,
												}}
											>
												La cuponera es un producto de tacoha que te
												permite comprar una cantidad de pasajes en blanco a un precio preferencial,
												para ser usados en orígenes y destinos específicos.
											</p>) : (<p
												style={{
													marginBottom: 22,
												}}
											>
												La cuponera es un producto de {selectedCuponera.operator_name} que te
												permite comprar una cantidad de pasajes en blanco a un precio preferencial,
												para ser usados en orígenes y destinos específicos.
											</p>)}

											<p
												className="bold-text"
												style={{
													marginBottom: 6,
												}}
											>
												La cuponera que seleccionaste puede ser utilizada en los siguientes orígenes
												y destinos (tanto ida como ida y vuelta):
											</p>
											<div className="row">
												{selectedCuponera.city_pairs.map(({ origin, destination }, key) => (
													<div
														class="col-6"
														style={{
															margin: '20px 0',
														}}
														key={key}
													>
														<span className="bold-text">{origin}</span> a{' '}
														<span className="bold-text">{destination}</span>
													</div>
												))}
											</div>
										</div>
									)}
								</div>
								{/*  */}
								<div className="relative cuponera-sidebar-wrapper">



									{operator && operator.operator_name === "tacoha" ?
										(<div className="cuponera-sidebar-relative tachoha-icon-size ">
											<div className="cuponera-sidebar kupos-card">
												<p className="bold-text">Detalles de la compra</p>
												<div className="cuponera-sidebar-hr" />
												{selectedCuponera && (
													<React.Fragment>
														<span className="font9">{selectedCuponera.operator_name}</span>
														<br />
														<span className="font9">{selectedCuponera.no_of_coupons} Pasajes</span>
														<div className="location-details">
															<div className="city-name font11">
																<img
																	className="icon-source"
																	src={getIcons('Origin', operator)}
																	alt={t('TRANSLATIONS.ICON_SOURCE')}
																/>
																<span className="font9">{selectedCuponera.origin}</span>
															</div>
															<div className="city-name font11">
																<img
																	className="icon-source"
																	src={getIcons('Destination', operator)}
																	alt={t('TRANSLATIONS.ICON_SOURCE')}
																/>
																<span className="font9">{selectedCuponera.destination}</span>
															</div>
														</div>
														<hr />
														<div className="d-flex justify-content-between mt-4">
															<span className="font9">{selectedCuponera.no_of_coupons} Pasajes</span>
															<span className="font9 bold-text">
																CLP{' '}
																{CommonService.currency(selectedCuponera.total_coupon_amount || 'NA')}
															</span>
														</div>
													</React.Fragment>
												)}
											</div>
											{selectedCuponera && (
												<div className="cuponera-sidebar-total-sum-box">
													<span className="font9 bold-text">Total</span>
													<span className="font9 bold-text">
														CLP {CommonService.currency(selectedCuponera.total_coupon_amount)}
													</span>
												</div>
											)}
											<button
												onClick={() => onContinueBtnClicked()}
												style={{
													background: !selectedCuponera
														? '#999'
														: operator && operator.color_codes && operator.color_codes.button_color
															? operator.color_codes.button_color
															: '',
													width: 'fit-content',
													cursor: selectedCuponera ? 'pointer' : 'not-allowed',
												}}
												disabled={!selectedCuponera}
												className="kupos-button home-selection-input-button less-bold-text mx-auto px-5"
												// onClick={search}
												type="submit"
											>
												<span>{t('HOME.CONTINUE')}</span>
											</button>
										</div>) :
										(<div className="cuponera-sidebar-relative">
											<div className="cuponera-sidebar kupos-card">
												<p className="bold-text">Detalles de la compra</p>
												<div className="cuponera-sidebar-hr" />
												{selectedCuponera && (
													<React.Fragment>
														<span className="font9">{selectedCuponera.operator_name}</span>
														<br />
														<span className="font9">{selectedCuponera.no_of_coupons} Pasajes</span>
														<div className="location-details">
															<div className="city-name font11">
																<img
																	className="icon-source"
																	src={getIcons('Origin', operator)}
																	alt={t('TRANSLATIONS.ICON_SOURCE')}
																/>
																<span className="font9">{selectedCuponera.origin}</span>
															</div>
															<div className="city-name font11">
																<img
																	className="icon-source"
																	src={getIcons('Destination', operator)}
																	alt={t('TRANSLATIONS.ICON_SOURCE')}
																/>
																<span className="font9">{selectedCuponera.destination}</span>
															</div>
														</div>
														<hr />
														<div className="d-flex justify-content-between mt-4">
															<span className="font9">{selectedCuponera.no_of_coupons} Pasajes</span>
															<span className="font9 bold-text">
																CLP{' '}
																{CommonService.currency(selectedCuponera.total_coupon_amount || 'NA')}
															</span>
														</div>
													</React.Fragment>
												)}
											</div>
											{selectedCuponera && (
												<div className="cuponera-sidebar-total-sum-box">
													<span className="font9 bold-text">Total</span>
													<span className="font9 bold-text">
														CLP {CommonService.currency(selectedCuponera.total_coupon_amount)}
													</span>
												</div>
											)}
											<button
												onClick={() => onContinueBtnClicked()}
												style={{
													background: !selectedCuponera
														? '#999'
														: operator && operator.color_codes && operator.color_codes.button_color
															? operator.color_codes.button_color
															: '',
													width: 'fit-content',
													cursor: selectedCuponera ? 'pointer' : 'not-allowed',
												}}
												disabled={!selectedCuponera}
												className="kupos-button home-selection-input-button less-bold-text mx-auto px-5"
												// onClick={search}
												type="submit"
											>
												<span>{t('HOME.CONTINUE')}</span>
											</button>
										</div>)

									}

								</div>
							</div>
						</React.Fragment>
					) : (
						<div className="no-results-found">
							<KuposSuccessFailure
								title={t('HOME.WE_ARE_SORRY')}
								subtitle={t('HOME.NO_COUPONS_FOUND')}
								infoText={t('HOME.TRY_OTHER_ROUTES')}
								t={t}
							>
								<div className="kupos-card">
									<form
										onSubmit={() => {
											fetchCuponeraSeats({
												url: ApiUrls.cuponeraSeats(
													home.pbSourceCity.value,
													home.pbDestinationCity.value,
													operator && operator.travel_ids,

												),
											});
										}}
									>
										<div className="home-selection-input-boxes" style={{ display: 'block' }}>
											<div className="home-selection-input-box font10">
												<span className="label font11">{t('HOME.ORIGIN')}</span>
												<KuposSelectBox
													reactSelect
													selectType="origin"
													options={home.uniqueCities || []}
													selectedOption={home.pbSourceCity}
													onChange={onSourceChange}
													icon={getIcons('Origin', operator)}
													hideArrow={true}
													error={error.source ? true : false}
													errorMessage={t(error.source)}
													placeholder={t('HOME.ORIGIN')}
													height={40}
													t={t}
												/>
											</div>

											<div className="home-selection-input-box font10">
												<span className="label font11">{t('HOME.DESTINATION')}</span>
												<KuposSelectBox
													reactSelect
													selectType="destination"
													selectRef={destinationRef}
													options={
														home.pbSourceCity
															? getOriginSelectedFilteredDestinations(
																home.uniqueCities,
																home.pbSourceCity,
															)
															: []
													}
													selectedOption={home.pbDestinationCity}
													onChange={onDestinationChange}
													icon={getIcons('Destination', operator)}
													hideArrow={true}
													error={error.destination ? true : false}
													errorMessage={t(error.destination)}
													placeholder={t('HOME.DESTINATION')}
													height={40}
													t={t}
												/>
											</div>

											<div className="home-selection-input-box font12 datebox">
												<button
													style={{
														background:
															operator && operator.color_codes && operator.color_codes.button_color
																? operator.color_codes.button_color
																: '',
													}}
													className="kupos-button home-selection-input-button less-bold-text "
													type="submit"
												>
													<img src={getIcons('Search', operator)} alt="" style={{ height: 30 }} />
													<span>{t('HOME.SEARCH')}</span>
												</button>
											</div>
										</div>
									</form>
								</div>
							</KuposSuccessFailure>
						</div>
					)
					}
				</div >
			)}
		</div >
	);
};

// export default CuponeraSeats;

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
		home: state.home,
		common: state.common,
		cuponera: state.cuponera,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(
			{
				...actions,
				...homeActions,
			},
			dispatch,
		),
	};
}
export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(withTranslation('common')(CuponeraSeats));



// WEBPACK FOOTER //
// ./src/features/cuponera/CuponeraSeats.js